import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-carousel.css';
import { UitkCarouselItem } from './uitk-carousel-item.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkCarouselItemList = function (props) {
    var children = props.children, l10n = props.l10n, size = props.size, currentIndex = props.currentIndex, itemCount = props.itemCount, itemProps = __rest(props, ["children", "l10n", "size", "currentIndex", "itemCount"]);
    var itemsVisible = itemProps.itemsVisible, carouselListRef = itemProps.carouselListRef;
    var newChildren = React.Children.toArray(children);
    var baseClassName = 'uitk-carousel-item-container';
    var getCarouselItems = function () {
        var items = newChildren;
        var currentItemsVisible = itemsVisible[size];
        // Determines the grouping to apply aria-hidden to.
        var startOfCurrentGroup = currentIndex;
        var startOfNextGroup = currentIndex + currentItemsVisible;
        var elements = React.Children.map(items, function (elm, i) {
            var ariaHidden = i < startOfCurrentGroup || i >= startOfNextGroup;
            var ariaLabel = l10n === null || l10n === void 0 ? void 0 : l10n.formatText('carousel.indexAndTotal', i + 1, itemCount);
            return (React.createElement(UitkCarouselItem, __assign({ key: i, ariaHidden: ariaHidden, ariaLabel: ariaLabel }, itemProps), elm));
        });
        return elements;
    };
    return (React.createElement("div", { className: getClassNameList(baseClassName), ref: carouselListRef, "data-stid": "carousel-list" }, getCarouselItems()));
};
UitkCarouselItemList.displayName = 'UitkCarouselItemList';

export { UitkCarouselItemList };
